import axios from 'axios';

function getCookie(name) {
    let re = new RegExp(name + "=([^;]+)"),
        value = re.exec(document.cookie);
    return (value != null) ? unescape(value[1]) : null;
}

axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-CSRFToken'] = getCookie('csrftoken');

const capiUrl = '/capi/';

function createResource(url) {
    return {
        get(params = {}) {
            let finalUrl = url;
            for (const [key, value] of Object.entries(params)) {
                if (finalUrl.includes(`{${key}}`)) {
                    finalUrl = finalUrl.replace(`{${key}}`, value);
                    delete params[key];
                }
            }
            return axios.get(finalUrl, { params })
                .then(r => ({ body: r.data }))
                .catch(e => Promise.reject({ body: e.response?.data || {}, status: e.response?.status }));
        },
        save(data = {}, params = {}) {
            let finalUrl = url;
            for (const [key, value] of Object.entries(params)) {
                if (finalUrl.includes(`{${key}}`)) {
                    finalUrl = finalUrl.replace(`{${key}}`, value);
                }
            }
            return axios.post(finalUrl, data)
                .then(r => ({ body: r.data }))
                .catch(e => Promise.reject({ body: e.response?.data || {}, status: e.response?.status }));
        },
        update(data = {}, params = {}) {
            let finalUrl = url;
            for (const [key, value] of Object.entries(params)) {
                if (finalUrl.includes(`{${key}}`)) {
                    finalUrl = finalUrl.replace(`{${key}}`, value);
                }
            }
            return axios.put(finalUrl, data)
                .then(r => ({ body: r.data }))
                .catch(e => Promise.reject({ body: e.response?.data || {}, status: e.response?.status }));
        },
        delete(params = {}) {
            let finalUrl = url;
            for (const [key, value] of Object.entries(params)) {
                if (finalUrl.includes(`{${key}}`)) {
                    finalUrl = finalUrl.replace(`{${key}}`, value);
                    delete params[key];
                }
            }
            return axios.delete(finalUrl, { params })
                .then(r => ({ body: r.data }))
                .catch(e => Promise.reject({ body: e.response?.data || {}, status: e.response?.status }));
        }
    };
}

function cached(resource) {
    let originalGet = resource.get;
    resource._cache = null;
    resource.get = function(params) {
        if (!resource._cache) {
            resource._cache = originalGet(params);
        }
        return resource._cache;
    };
    return resource;
}

export const services = {
    Login: () => createResource(capiUrl + 'users/login'),
    Register: () => createResource(capiUrl + 'users/register'),
    Context: () => createResource(capiUrl + 'users/context'),
    Logout: () => createResource(capiUrl + 'users/logout'),
    Forgot: () => createResource(capiUrl + 'users/forgot'),
    Reset: () => createResource(capiUrl + 'users/reset'),
    Password: () => createResource(capiUrl + 'users/password'),
    WikiArticle: () => createResource(capiUrl + 'wiki/article/{slug}'),
    WikiIndex: () => createResource(capiUrl + 'wiki/index'),
    Plan: () => createResource(capiUrl + 'users/plan'),
    Data: () => cached(createResource(capiUrl + 'dash/data')),
    Stats: () => createResource(capiUrl + 'dash/stats'),
    Token: () => createResource(capiUrl + 'users/token'),
    PromoCode: () => createResource(capiUrl + 'users/promocode'),
    Transaction: () => createResource(capiUrl + 'users/transaction'),
    Payment: () => createResource(capiUrl + 'users/payment'),
    PaymentSystem: () => createResource(capiUrl + 'users/payment/system'),
    Invoice: () => createResource(capiUrl + 'users/invoice/{id}'),
    Review: () => createResource(capiUrl + 'users/review'),
    TgLogin: () => createResource(capiUrl + 'users/tg-login'),
    TgComplete: () => createResource(capiUrl + 'users/tg-complete'),
    BlogPosts: () => createResource(capiUrl + 'blog/posts'),
    BlogPost: () => createResource(capiUrl + 'blog/posts/{slug}'),
    Releases: () => createResource(capiUrl + 'releases/'),
    Status: () => cached(createResource(capiUrl + 'status')),
    Webhooks: () => createResource(capiUrl + 'webhooks'),
    Webhook: () => createResource(capiUrl + 'webhooks/{id}'),
    WebhookRotate: () => createResource(capiUrl + 'webhooks/{id}/rotate-secret'),
    WebhookStatus: () => createResource(capiUrl + 'webhooks/{id}/status'),
};

export default services;
